<template>
<div>
  <div class="wrapper">
      <div class="content">
              亲爱的小狼人，活动已经结束啦~
          </div>
      <div class="button-wrapper">
          
          <!-- <img src="../../assets/modal/confirm5.png" alt="" class="button"  @click="$emit('loginTip-confirm')"> -->
          <!-- <img src="../../assets/modal/confirm3.png" alt="" class="button"  @click="$emit('wishComplete-reselect')"> -->
      </div>
      
  </div>
</div>
</template>

<script>
export default {
    name: 'loginTip',
    data() {
        return {
        }
    },
    methods: {
       
    }
}
</script>

<style lang="scss" scoped>
.wrapper {
    width: 91.76vw;
    margin: 0 auto;
    margin-top: 12vw;
    min-height: 61.11vw;
    background-image: url("../../assets/modal/complete.png");
    background-size: 100% 100%;
    overflow: hidden;
    .content {
        margin: 16vw auto 0;
        width: 66%;
        text-align: center;
        min-height: 24vw;
        font-size: 22px;
        font-weight: bold;
    }
    .button-wrapper {
        display: flex;
        justify-content: center;
         align-items: center;
    }
    .button {
        width: 34.26vw;
        margin: 2vw 2vw;
        display: block;
        flex-shrink: 0;
    }
}

</style>